import { render, staticRenderFns } from "./InstanceGroupInstanceDeleteModal.vue?vue&type=template&id=81586600&scoped=true&"
import script from "./InstanceGroupInstanceDeleteModal.vue?vue&type=script&lang=ts&"
export * from "./InstanceGroupInstanceDeleteModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81586600",
  null
  
)

export default component.exports